import app from '../app.first';
import $ from 'jquery';

app.JobView = class extends app.Component {
	onReady() {
        let modalOpen = $('#applyButtonModal');
        let modalClose = $('#jobModalClose');

        modalOpen.click(() => {
            $('.job-modal-container').css('display', 'flex');
        })

        modalClose.click(() => {
            $('.job-modal-container').css('display', 'none');
        })
	}
}